<script lang="ts" setup>
import CatalogDesktopFilters from '~/widgets/catalog/products/filters/CatalogDesktopFilters.vue';
import MobileFilter from '~/widgets/mobileFilters/MobileFilter.vue';
import CatalogSelectedFilters from '~/widgets/catalog/products/content/CatalogSelectedFilters.vue';
import CatalogSorting from '~/widgets/catalog/products/content/CatalogSorting.vue';
import CatalogContent from '~/widgets/catalog/products/content/CatalogContent.vue';
import Pagination from '~/components/ui/pagination/Pagination.vue';
import useCatalogStore from '~/shared/store/modules/catalog';
import { useMonitorSize } from '~/composables/monitor-size';
import type { IMonitorSize } from '~/shared/interfaces/composables';
import type { IFiltersListWithActivity } from '~/shared/interfaces/filtersList';
import CatalogMobileFilters from "~/widgets/catalog/products/filters/CatalogMobileFilters.vue";

const catalogStore = useCatalogStore();
const filtersModalIsOpen = ref(false);
let sizes: IMonitorSize | null = useMonitorSize();

const getFiltersList = computed(() => {
  if (catalogStore.filters.length) {
    return catalogStore.filters.reduce((acc, { id, title, values }) => {
      acc[id] = {
        name: title,
        value: id,
        items: values.map(filterValue => {
          return {
            value: filterValue.value,
            name: filterValue.title || filterValue.value,
            active: filterValue.active,
          }
        })
      }

      return acc;
    }, {} as {[value: string]: IFiltersListWithActivity})
  }
})

function closeFiltersModalModal() {
  filtersModalIsOpen.value = false;
}

function watchMoreCatalogProducts(page: number) {
  catalogStore.setProductsReplaceStatus(true);
  catalogStore.setCurrentPage(page);
}

</script>

<template>
  <div class="catalog-info">
    <CatalogDesktopFilters v-if="!sizes?.isMobile"/>
    <CatalogMobileFilters v-if="sizes?.isMobile"/>
    <div class="catalog-info__content-wrapper">
      <CatalogSorting v-if="!sizes?.isMobile"/>
      <CatalogSelectedFilters
        v-if="catalogStore.selectedFilters.brands.length || catalogStore.selectedFilters.filters.length"
        class="catalog-info__filters"
      />
      <CatalogContent class="catalog-info__content"/>

      <Pagination
        v-if="catalogStore.catalog && catalogStore.catalog.lastPage > 1"
        class="catalog-info__pagination"
        :last-page="catalogStore.catalog.lastPage"
        :current-page="catalogStore.selectedFilters.page"
        :pagination-type="sizes.browserWidth < 1199 || sizes.isMobile ? 'watch-more' : undefined"
        @handle-pagination="catalogStore.setCurrentPage"
        @handle-watch-more="watchMoreCatalogProducts"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.catalog {
  &-info {
    display: flex;
    gap: 36px;
    padding-top: 16px;
    @include md-breakpoint {
      padding: 0;
    }

    &__content {
      &-wrapper {
        width: 100%;
        @include md-breakpoint {
          border-top: 2px solid $bg_border;
          padding-top: 16px;
        }
      }
    }

    &__filters {
      padding: 16px 12px 20px;
      @include md-breakpoint {
        padding: 0;
      }
    }

    &__pagination {
      margin-top: 40px;
    }

    @include md-breakpoint {
      flex-direction: column;
      gap: 0;
    }
  }
}
</style>
